import classNames from 'classnames/bind';
import styles from './EbookActivityDetails.module.css';
import { TIME_CHART_CONFIG } from '../../../constants/config';
import { getTopLevels } from '../../../utils/util';

const cx = classNames.bind(styles);

interface TimeChartProps {
  data: { title: string; value: number }[];
}

export default function TimeChart({ data }: TimeChartProps) {
  const {
    SEGMENT_ANGLE,
    RADIUS,
    LABEL_RADIUS,
    CENTER_X,
    CENTER_Y,
    OFFSET_X,
    OFFSET_Y,
  } = TIME_CHART_CONFIG;

  const values = data.map((item) => item.value);
  const levels = getTopLevels(values);

  const getColor = (value: number) => {
    if (levels.highest.includes(value)) return 'var(--chart-time-level-1)';
    if (levels.second.includes(value)) return 'var(--chart-time-level-2)';
    return 'var(--chart-time-level-3)';
  };

  const createSegmentPath = (index: number) => {
    const startAngle = index * SEGMENT_ANGLE;
    const endAngle = (index + 1) * SEGMENT_ANGLE;
    const startRad = (startAngle - 90) * (Math.PI / 180);
    const endRad = (endAngle - 90) * (Math.PI / 180);

    const x1 = CENTER_X + RADIUS * Math.cos(startRad);
    const y1 = CENTER_Y + RADIUS * Math.sin(startRad);
    const x2 = CENTER_X + RADIUS * Math.cos(endRad);
    const y2 = CENTER_Y + RADIUS * Math.sin(endRad);

    return `M${CENTER_X},${CENTER_Y} L${x1},${y1} A${RADIUS},${RADIUS} 0 0,1 ${x2},${y2} Z`;
  };

  return (
    <>
      <svg
        className={cx('chart_svg')}
        width="187"
        height="187"
        viewBox="0 0 187 187"
      >
        {data.map((item, index) => (
          <path
            key={index}
            d={createSegmentPath(index)}
            fill={getColor(item.value)}
            stroke="var(--color-text-white)"
            strokeWidth="1"
          />
        ))}
      </svg>
      {data.map((item, index) => {
        const angle =
          ((index * SEGMENT_ANGLE + SEGMENT_ANGLE / 2 - 90) * Math.PI) / 180;
        let x = CENTER_X + Math.cos(angle) * LABEL_RADIUS;
        let y = CENTER_Y + Math.sin(angle) * LABEL_RADIUS;

        if (Math.cos(angle) < 0) {
          x += OFFSET_X;
        } else if (Math.cos(angle) > 0) {
          x -= OFFSET_X;
        }

        if (Math.sin(angle) < 0) {
          y += OFFSET_Y;
        } else if (Math.sin(angle) > 0) {
          y -= OFFSET_Y;
        }

        const isHighest = levels.highest.includes(item.value);

        return (
          <div
            key={`label-${index}`}
            className={cx('time_chart_label', { highest_level: isHighest })}
            style={{ left: `${x}px`, top: `${y}px` }}
          >
            {item.title}
          </div>
        );
      })}
    </>
  );
}
